import { cpf } from 'cpf-cnpj-validator';

const Yup = require('yup');

function validateDocument(document) {
  if (document) {
    const valid = cpf.isValid(document);

    return valid;
  }
  return false;
}

const productSchema = Yup.object().shape({
  product: Yup.object()
    .required('Produto é obrigatório')
    .typeError('Produto é obrigatório'),

  productQuantity: Yup.number()
    .positive('Quantidade deve ser positiva')
    .min(1)
    .required('Quantidade é obrigatória')
    .typeError('Quantidade é obrigatória'),
});

const schema = Yup.object().shape({
  cpf: Yup.string().test(
    'invalid-cpf',
    'CPF inválido ou precisa ser preenchido',
    value => validateDocument(value)
  ),

  cnpj: Yup.string().required('CNPJ é obrigatório'),

  type: Yup.mixed(),
});

const firstStepSchema = Yup.object().shape({
  cpf: Yup.string()
    .test('invalid-cpf', 'CPF inválido ou precisa ser preenchido', value =>
      validateDocument(value)
    )
    .length(11, 'CPF deve ter 11 dígitos'),
  type: Yup.mixed(),
  token: Yup.mixed(),
});

export default schema;
export { productSchema, firstStepSchema };
